"use client"

import { Authenticated } from "@refinedev/core"
import { ThemedLayout } from "@refinedev/mui"
import { AppTitle } from "@/components/layout/app-title"
import { AppHeader } from "@/components/layout/app-header"
import { AppFooter } from "@/components/layout/app-footer"
import { AppSider } from "@/components/layout/app-sider"
import { AppQuickCreate } from "@/components/layout/app-quick-create"
import { NewDayGreetingDialog } from "@/components/layout/new-day-greeting-dialog"

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <Authenticated key="dashboard">
      <ThemedLayout
        Footer={AppFooter}
        Sider={AppSider}
        Header={AppHeader}
        Title={AppTitle}
        containerBoxProps={{ sx: { minHeight: "100vh" } }}
        childrenBoxProps={{ sx: { p: { xs: 1.5, md: 2.5, lg: 3 } } }}
      >
        <>
          {children}
          <AppQuickCreate />
          <NewDayGreetingDialog />
        </>
      </ThemedLayout>
    </Authenticated>
  )
}
